import React from 'react';
import styles from './Sidebar.module.css';
import SidebarData from "./SidebarData/SidebarData";
import {Col, Row} from "react-bootstrap";
// import {Menu} from '@mui/icons-material';

// import '../App.css';
function Sidebar() {
    return (
        <Row className={styles.Sidebar}>
            {/*<ul className='SidebarList'>*/}
            {/*    <li>*/}
            {/*        <div id='icon' className=''><Menu/></div>*/}
            {/*    </li>*/}
            {/*</ul>*/}
            {/*<hr/>*/}
            <Col className={styles.SidebarList}>
                {SidebarData.map((item, key) => {
                    return (
                        <li key={key}
                            className={styles.SidebarRow}
                            id={window.location.pathname === item.link ? styles.active : ""}
                            onClick={() => {
                                window.location.pathname = item.link
                            }}>
                            <div id={styles.icon}>{item.icon}</div>
                            <div id={styles.title}>
                                {item.title}
                            </div>
                        </li>
                    );
                })}
            </Col>
        </Row>
    );
}

export default Sidebar;
